import React, { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { get as _get } from 'lodash'

import SEOHead from '../utilities/SEOHead'
import useAuth from '../../utilities/hooks/useAuth'
import LoginPage from './LoginPage'
import getAuthenticatedRedirectPath from '../../utilities/getAuthenticatedRedirectPath'

function LoginFeature() {
  const { isSignedIn, currentUser } = useAuth()
  const location = useLocation()
  const history = useHistory()
  const notificationMessage = _get(location, 'state.message')

  useEffect(() => {
    if (isSignedIn && currentUser) {
      history.push(getAuthenticatedRedirectPath(currentUser, location.state))
    }
  }, [isSignedIn, currentUser, history, location])

  return (
    <>
      <SEOHead
        title="Login"
        description="Log in to your Leevo account to manage your sports program, view class schedules, and track student progress."
        path="/login"
        noindex={false}
      />
      <LoginPage notificationMessage={notificationMessage} />
    </>
  )
}

export default LoginFeature
